import Layout from "../components/site/Layout";
import { PageHeader } from "../components/site/Primitives";
import GatedForm from "../components/site/GatedForm";

const BULLETS = [
  "Legal foundation: Swanson v. Commissioner (1996) and the IRS's acknowledgment of IRA-LLC structures",
  "Tax law framework: the FMV standard, IRS Interpretive Letter EP:R:9, and how conversion income is determined",
  "The two discounts explained: DLOC and DLOM mechanics and the sequential application method",
  "IRS published guidance: Rev. Rul. 59-60, the 2009 DLOM Job Aid, IRM 4.48.4",
  "11-decision Tax Court case table with combined discounts, key principles, and citations",
  "Operating agreement analysis: section-by-section review of provisions that legally drive the discount",
  "Legal opinion summary from Kent Savage, Esq. — estimated discount basis and conclusions",
  "IRS challenge history: published cases, audit exposure analysis, and §2704 regulatory history",
  "Compliance framework: discount range tables, documentation requirements, statute of limitations",
];

const ROLE_OPTIONS = [
  "CPA or Tax Professional",
  "CFP or Financial Advisor or RIA",
  "Estate Planning Attorney",
  "Tax Attorney",
  "Wealth Manager or Family Office",
  "Prospective Client (self or family)",
  "Other",
];

const STATS = [
  { v: "~30", k: "Pages" },
  { v: "11", k: "Tax Court cases" },
  { v: "1", k: "Legal opinion" },
];

const DISCLAIMER =
  "This white paper is shared in confidence as a professional research resource. It is not intended for redistribution. Discount ranges referenced are illustrative; actual discounts are determined by independent appraisal. By submitting, you acknowledge that the content is proprietary to Retirement Tax Consultants, LLC. Our team will follow up within one business day.";

const TEST_IDS = {
  form: "white-paper-form",
  success: "white-paper-success",
  prefix: "wp",
};

export default function WhitePaperGatePage() {
  return (
    <Layout pageName="white-paper-gate">
      <PageHeader
        eyebrow="Professional Research Document"
        title="Valuation Discounts in IRA-LLC Structures:"
        italicTail="A Legal and Strategic Framework"
        intro="A comprehensive analysis of the legal basis, IRS guidance, Tax Court precedent, and compliance framework for applying DLOC and DLOM discounts to IRA-owned LLC interests in the context of Roth conversions."
      />

      <section className="pb-24 lg:pb-32 bg-cream">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-10 grid lg:grid-cols-12 gap-12">
          <div className="lg:col-span-7">
            <div className="grid grid-cols-3 gap-px bg-sage/30 border border-sage/30">
              {STATS.map((s) => (
                <div key={s.k} className="bg-cream p-5 lg:p-6">
                  <div className="font-serif text-deep-teal text-4xl lg:text-5xl">
                    {s.v}
                  </div>
                  <div className="mt-2 text-[10px] tracking-overline uppercase font-semibold text-charcoal-teal/60">
                    {s.k}
                  </div>
                </div>
              ))}
            </div>

            <p className="mt-10 text-charcoal-teal leading-relaxed">
              Developed to provide CPAs, financial advisors, estate planning
              attorneys, and other qualified professionals with the legal and
              analytical foundation needed to evaluate this strategy for
              client situations. Includes supporting legal opinion from tax
              counsel.
            </p>

            <div className="mt-12 text-[10px] tracking-overline uppercase font-semibold text-accent-gold">
              What&rsquo;s Inside
            </div>
            <ul className="mt-4 border-t border-sage-soft">
              {BULLETS.map((b, i) => (
                <li
                  key={b}
                  className="grid grid-cols-12 gap-4 py-5 border-b border-sage-soft items-start"
                >
                  <div className="col-span-1 text-[10px] tracking-overline font-semibold text-accent-gold pt-1">
                    §{String(i + 1).padStart(2, "0")}
                  </div>
                  <div className="col-span-11 text-deep-teal text-base leading-relaxed">
                    {b}
                  </div>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-5">
            <div className="bg-cream-alt p-8 lg:p-10 border border-sage/30 lg:sticky lg:top-32">
              <GatedForm
                endpoint="/lead-magnet/white-paper"
                trackingEvent="white_paper_submit"
                eyebrow="Request White Paper"
                title="Professional research request."
                submitLabel="Request the White Paper"
                roles={ROLE_OPTIONS}
                requireFirm
                requireRole
                showInterest
                disclaimer={DISCLAIMER}
                testIds={TEST_IDS}
              />
            </div>
          </div>
        </div>
      </section>
    </Layout>
  );
}
